import { useMemo } from 'react';
import { Select } from '../select';
import { COUNTRY_OPTIONS } from './country-codes';

type CountrySelectProps = {
  value: string | null;
  onChange: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
  excludeCodes?: readonly string[];
};

export const CountrySelect = ({
  value,
  onChange,
  disabled,
  placeholder = 'Select country',
  excludeCodes,
}: CountrySelectProps) => {
  const options = useMemo(() => {
    if (!excludeCodes || excludeCodes.length === 0) {
      return COUNTRY_OPTIONS.map((c) => ({ value: c.value, label: c.label }));
    }
    // Keep the current value visible even if it's in the exclude list — the
    // form passes the current row's value so the user can re-pick the same
    // country when editing.
    const blocked = new Set(excludeCodes.filter((c) => c !== value));
    return COUNTRY_OPTIONS.filter((c) => !blocked.has(c.value)).map((c) => ({
      value: c.value,
      label: c.label,
    }));
  }, [excludeCodes, value]);

  return (
    <Select
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      options={options}
      placeholder={placeholder}
      searchable
      value={value ?? ''}
    />
  );
};
